import { render, staticRenderFns } from "./BaseExpandableMenu.vue?vue&type=template&id=000af310&scoped=true"
import script from "./BaseExpandableMenu.vue?vue&type=script&lang=js"
export * from "./BaseExpandableMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseExpandableMenu.vue?vue&type=style&index=0&id=000af310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000af310",
  null
  
)

export default component.exports